import React from 'react';
import {connect} from "react-redux";
import {RootState} from "../../../../../reducers";
import {withTranslation} from "react-i18next";
import MenuScrollSpy from "../../../../utils/MenuScrollSpy";
import ScrollableTabs from "../../../../components/Common/ScrollableTabs";
import {getSession} from "../../../../services/Session/reducer";
import MenuCategoriesNavbarItem from "./MenuCategoriesNavbarItem";
import {CategoryViewType} from "../../../../services/Api/types";
import {getStoreConfig} from "../../../../services/Store/reducer";
import StoreUtils from "../../../../services/Store/StoreUtils";

interface OwnProps {
    promotions: any[];
    categories: any[];
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const MenuCategoriesNavbar = ({categories, session, config}: Props) => {
    const viewType = StoreUtils.getMenuCategoryViewType(config);

    return (
        <div className="container-fluid">
            <ScrollableTabs hideScrollbars={false}
                            className={`nav-categories-wrapper ${viewType === CategoryViewType.IMAGE ? "nav-categories-wrapper-with-images" : ""}`}
                            scrollStep={60}>
                <MenuScrollSpy value={session.order_type} productsViewType={StoreUtils.getMenuProductsViewType(config)}>
                    <ul className={`nav flex-nowrap align-items-start ${viewType === CategoryViewType.BASIC ? "gap-4" : "gap-2"}`}>
                        {
                            categories.map((category, index) => (
                                    <MenuCategoriesNavbarItem key={`${category.id}-${session.order_type}`}
                                                              category={category} index={index}
                                                              type={viewType} config={config}
                                                              orderType={session.order_type}/>
                                )
                            )
                        }
                    </ul>
                </MenuScrollSpy>
            </ScrollableTabs>
        </div>
    )
}

const mapStateToProps = (state: RootState) => ({
    session: getSession(state.session),
    config: getStoreConfig(state.config),
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(MenuCategoriesNavbar));
